import React, { createContext, useContext, useState, useEffect, ReactNode } from "react";
import ptBR from "./pt-BR.json";
import enUS from "./en-US.json";
import esES from "./es-ES.json";

type Languages = "pt-BR" | "en-US" | "es-ES";

const langs = { "pt-BR": ptBR, "en-US": enUS, "es-ES": esES };

interface I18nContextType {
  language: Languages;
  setLanguage: (lang: Languages) => void;
  t: (key: string) => string;
}

const I18nContext = createContext<I18nContextType | undefined>(undefined);

export const I18nProvider = ({ children }: { children: ReactNode }) => {
  const [language, setLanguageState] = useState<Languages>("pt-BR");

  const setLanguage = (lang: Languages) => {
    setLanguageState(lang);
    localStorage.setItem("preferredLanguage", lang);
  };

  useEffect(() => {
    const savedLang = localStorage.getItem("preferredLanguage") as Languages | null;
    if (savedLang && langs[savedLang]) {
      setLanguageState(savedLang);
    }
  }, []);

  const t = (key: string) => {
    return key.split(".").reduce((obj: any, k: string) => obj?.[k], langs[language]) || key;
  };

  return (
    <I18nContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => {
  const context = useContext(I18nContext);
  if (!context) throw new Error("useI18n must be used within I18nProvider");
  return context;
};

